<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap class="ss-layout">
      <v-flex xs12 sm6 order-xs2 order-sm1>
        <h2>{{ $t("your-orders") }}</h2>
        <v-divider class="mb-3"></v-divider>

        <div class="text-xs-center" v-if="length > 1">
          <v-pagination
            v-model="page"
            :length="length"
            total-visible=5
            color="#000"
            @input="nextPage"
          ></v-pagination>
        </div>

        <div v-for="(order, key) in orders" :key="key">
          <div class="pa-2">
            <v-layout row wrap style="margin:20px 0 20px 0;">
              <v-flex xs12 sm12 md6 style="padding-top:0;padding-bottom:0;">
                <div><v-chip color="dark darken-1">{{ $t("order-number") }}</v-chip> {{ order.orders_number }}</div>
                <div><v-chip color="dark darken-1">{{ $t("purchase-datetime") }}</v-chip> {{ order.orders_created_at }}</div>
              </v-flex>
              <v-flex xs12 sm12 md6 style="padding-top:0;padding-bottom:0;">
                <div><v-chip color="dark darken-1">{{ $t("amount") }}</v-chip> ¥{{ order.orders_amount }}</div>
              </v-flex>
            <v-layout>
            <v-layout row wrap style="margin-top:20px;">
              <v-flex xs12>
                <v-list-tile v-for="(item, key2) in order.orders_works" :key="key2" avatar style="height:100px;">
                  <v-list-tile-avatar size="75" style="margin-right:15px;">
                    <img :src="'/service/img/public/works/' + item.works_img">
                  </v-list-tile-avatar>

                  <v-list-tile-content style="height:100px;margin-top:10px;">
                    <v-list-tile-sub-title>{{ item.works_code }}</v-list-tile-sub-title>
                    <v-list-tile-title>{{ item.works_details_title }}</v-list-tile-title>
                    <v-list-tile-sub-title>¥{{ item.orders_works_price }}</v-list-tile-sub-title>
                    <v-list-tile-sub-title><router-link :to="'/creator/' + item.creators_id">{{ item.creators_first_name }} {{ item.creators_last_name }}</router-link></v-list-tile-sub-title>
                  </v-list-tile-content>

                  <v-list-tile-action>
                    <v-btn icon ripple　@click="download(item.works_code)">
                      <v-icon color="grey lighten-1">save_alt</v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </v-list-tile>
              </v-flex>
            <v-layout>
          </div>
          <v-divider></v-divider>
        </div>

        <div class="text-xs-center" v-if="length > 1">
          <v-pagination
            v-model="page"
            :length="length"
            total-visible=5
            color="#000"
            @input="nextPage"
          ></v-pagination>
        </div>

      </v-flex>
      <v-flex xs12 sm6 order-xs1 order-sm2>
        <h2>{{ $t("settings") }}</h2>
        <v-divider class="mb-3"></v-divider>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  export default {
    data() {
      return {
        page: 1,
        length: 0,
        orders: [],
      };
    },
    created() {
      this.$emit('getAuth');
      if (!this.$store.state.auth) {
        this.$router.replace({ path: '/' });
      }
      this.$emit('getItemsFromCart');
      this.getOrders();
    },
    computed: {
      locale: {
        get:function () { return this.$store.state.locale }
      }
    },
    watch: {
      locale: function() {
        this.getOrders();
      }
    },
    methods: {
      nextPage(page) {
        this.page = page;
        this.getOrders(true);
      },
      getOrders(scrollTop) {
        this.$axios.get("/service/api/users/orders/" + this.page)
          .then(response =>  {
            this.orders = response.data.orders;
            this.length = response.data.length;
            if(scrollTop) {
              window.scroll(0, 0);
            }
          }).catch(error => {
            this.$emit('showNotification', 'error', error.response.data.error.message);
          });
      },
      download(worksCode) {
        location.href = "/service/img/download/" + worksCode;
      }
    },
  };
</script>
